export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_00.f310cfa7.jpg";